import { AlertCircle, X } from "lucide-react"
import { Button } from "@/components/ui/button"

interface ChatErrorBannerProps {
  error: string | null
  /** Shown when there is a user message to resend. */
  onRetry?: (() => void) | undefined
  onDismiss: () => void
}

/** The error line above a chat composer (Assistant page, Tender Chat, assistant dock). */
export function ChatErrorBanner({ error, onRetry, onDismiss }: ChatErrorBannerProps) {
  if (!error) return null
  return (
    <div className="mx-4 mb-2 flex items-center gap-2 rounded-lg border border-destructive/30 bg-destructive/5 px-3 py-2 text-sm text-destructive">
      <AlertCircle className="h-4 w-4 shrink-0" />
      <span className="flex-1">{error}</span>
      {onRetry && (
        <Button variant="ghost" size="sm" className="h-6 px-2 text-xs shrink-0" onClick={onRetry}>
          Retry
        </Button>
      )}
      <button onClick={onDismiss} className="shrink-0 rounded p-0.5 hover:bg-destructive/10" aria-label="Dismiss error">
        <X className="h-3.5 w-3.5" />
      </button>
    </div>
  )
}
